import {useDrag} from "react-dnd";
import React from "react";

const DragElement = (props) => {
  const [, drag] = useDrag({
    item: {
      name: "drag-" + props.name,
      type: props.type,
      train: props.train,
      el: props.el,
      elID: props.elID,
    }
  });

  return <div className={"card-drag" + (props.canDrag ? " can-drag" : "")} ref={props.canDrag ? drag : null}>
    {props.content}
  </div>
}

export default DragElement;
